import gql from 'graphql-tag';

export default gql`
mutation ($budgetLineIds: [String], $externalMapIds: [DeleteExternalMapsInput]) {
    deleteBatchBudgetLine (budgetLineIds: $budgetLineIds, externalMapIds: $externalMapIds) {
        __typename
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/BudgetLines/DeleteBatchMutation.js